import { createSelector } from 'reselect'
import * as R from 'ramda'
import {
  PAGE,
  FILE_TYPE
} from './constants'

const activeSelector = state => state.project.projectNvqual.fileUpload.active
const pageSelector = state => state.project.projectNvqual.fileUpload.page
const reportBodySelector = state => state.project.projectNvqual.fileUpload.reportBody
const reportUrlSelector = state => state.project.projectNvqual.fileUpload.reportUrl
const newRevisionNameSelector = state => state.project.projectNvqual.fileUpload.newRevisionName
const filesSelector = state => state.project.projectNvqual.fileUpload.files
const createNvbugSelector = state => state.project.projectNvqual.fileUpload.createNvbug

const isUploadingSelector = createSelector(
  pageSelector,
  R.equals(PAGE.UPLOADING)
)

export {
  activeSelector,
  pageSelector,
  isUploadingSelector,
  reportBodySelector,
  reportUrlSelector,
  newRevisionNameSelector,
  filesSelector,
  createNvbugSelector
}
